export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-v1-480-d09cefe30bdcbdc2a4ee83f53c1c39bd.webp";